// extracted by mini-css-extract-plugin
module.exports = {"header":"MainHeader_header__1MtEk","logo":"MainHeader_logo__T0Ewc","home":"MainHeader_home__3AOgV","menu":"MainHeader_menu__1NLSS"};